import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavContext } from "../context/nav_context";
import { TfiClose } from "react-icons/tfi";
import { links } from "../utils/constants";
import styled from "styled-components";

const Sidebar = () => {
  const twitterUrl = "https://twitter.com/Aoe2ESP";
  const discordUrl = "https://discord.gg/ZXkABxKFq5";
  const { isSidebarOpen, closeSidebar, user } = useNavContext();
  const [userInfo, setUserInfo] = useState(user);

  useEffect(() => {
    if (user) {
      let userDetails = user;
      if (typeof userDetails === "string") {
        userDetails = JSON.parse(userDetails);
      }
      setUserInfo(userDetails);
    }
  }, [user]);

  return (
    <Container>
      <Panel className={isSidebarOpen ? "visible" : ""}>
        <Header>
          <LogoImg
            src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/lea_t9.png"
            alt="Liga Española"
          />
          <CloseIcon onClick={closeSidebar}>
            <TfiClose />
          </CloseIcon>
        </Header>
        <NavLinks>
          {links
            .filter(l => !l.adminOnly || (userInfo && userInfo.isAdmin))
            .map(({ id, text, url }) => (
            <li key={id}>
              <NavItem to={url} onClick={closeSidebar}>
                {text}
              </NavItem>
            </li>
          ))}
          {userInfo && (userInfo.isAdmin || userInfo.isModerator) ? (
            <li>
              <NavItem to="/admin" onClick={closeSidebar}>
                Admin
              </NavItem>
            </li>
          ) : null}
        </NavLinks>
        <SocialRow>
          <SocialImg
            src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/twitter.jpg"
            alt="twitter"
            onClick={() => window.open(twitterUrl, "_blank")}
          />
          <SocialImg
            src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/discord_color.jpg"
            alt="discord"
            onClick={() => window.open(discordUrl, "_blank")}
          />
        </SocialRow>
      </Panel>
      {isSidebarOpen && <Backdrop onClick={closeSidebar} />}
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: 200;
  pointer-events: none;
`;

const Panel = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  height: 100%;
  background: var(--v-surface);
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  z-index: 201;
  display: flex;
  flex-direction: column;
  transform: translateX(-100%);
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  &.visible {
    transform: translateX(0);
    pointer-events: auto;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 200;
  pointer-events: auto;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
`;

const LogoImg = styled.img`
  width: 100px;
  object-fit: contain;
`;

const CloseIcon = styled.div`
  color: var(--v-fg-muted);
  cursor: pointer;
  font-size: 18px;
  display: flex;
  transition: color var(--v-transition);

  &:hover {
    color: var(--v-fg);
  }
`;

const NavLinks = styled.ul`
  list-style: none;
  margin: 0;
  padding: 1rem 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const NavItem = styled(Link)`
  display: block;
  padding: 0.85rem 1.25rem;
  font-family: var(--v-font-body);
  font-size: 15px;
  font-weight: 500;
  color: var(--v-fg);
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: background var(--v-transition), color var(--v-transition);

  &:hover {
    background: rgba(60, 255, 208, 0.04);
    color: var(--v-mint);
  }
`;

const SocialRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.25rem;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
`;

const SocialImg = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity var(--v-transition);

  &:hover {
    opacity: 1;
  }
`;

export default Sidebar;
